<div class="content__inner">
    <header class="content__title">
        <h1>{{ "distributors.details.title" | translate }}</h1>
        <div class="actions">
            <button (click)="back()" class="btn btn-secondary btn--icon-text"><i class="zmdi zmdi-arrow-back"></i> {{ "global.buttons.back" | translate }}</button>
        </div>
    </header>

    <div class="card" *appHasPermission="'CHECKLIST.LIST'">
        <div class="card-body">
            <div class="row">
                <div class="information-container">
                    <h4 class="card-title">{{ "distributors.details.props.gpsCoords" | translate }}</h4>
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>{{ "distributors.details.props.gpsLatitude" | translate }}</label>
                                <input
                                    class="form-control"
                                    id="latitude"
                                    placeholder="{{ 'distributors.details.props.gpsLatitude' | translate }}"
                                    type="number"
                                    [(ngModel)]="displayedGpsCoords.lat"
                                    (keyup)="onCoordsChanged({ lat: displayedGpsCoords.lat })"
                                /><i class="form-group__bar"></i>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>{{ "distributors.details.props.gpsLongitude" | translate }}</label>
                                <input
                                    class="form-control"
                                    id="longitude"
                                    placeholder="{{ 'distributors.details.props.gpsLongitude' | translate }}"
                                    type="number"
                                    [(ngModel)]="displayedGpsCoords.lng"
                                    (keyup)="onCoordsChanged({ lng: displayedGpsCoords.lng })"
                                /><i class="form-group__bar"></i>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4" id="distributor-adress" *ngIf="distributor !== null">
                        <div class="form-group">
                            <div>{{ distributor.name }}</div>
                            <div>{{ distributor.street }}</div>
                            <div>{{ distributor.postcode }} {{ distributor.city }}</div>
                        </div>
                    </div>
                </div>

                <div class="map-container">
                    <div id="map"></div>

                    <!-- prettier-ignore -->
                    <script>(g=>{var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src=`https://maps.${c}apis.com/maps/api/js?`+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})
        ({key: "", v: "weekly"});</script>
                </div>
            </div>

            <div class="col-12 mt-5">
                <span>
                    <button type="button" (click)="save()" class="btn btn-success btn--icon-text float-right ml-2 mb-2" [disabled]="isSaveDisabled()"><i class="zmdi zmdi-check"></i> {{ "global.buttons.save" | translate }}</button>
                </span>
            </div>
        </div>
    </div>
</div>
